var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopAppleMacbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 12V27H8L8 12L20 12C19.7239 12 19.5 12.2239 19.5 12.5C19.5 12.7761 19.7239 13 20 13H8.5L8.5 25.5H31.5L31.5 13H20C20.2761 13 20.5 12.7761 20.5 12.5C20.5 12.2239 20.2761 12 20 12H32ZM32 11C32.5523 11 33 11.4477 33 12V27.5H36V29.5C36 29.75 34.25 30 33.25 30H6.75C5.75 30 4 29.75 4 29.5V27.5H7L7 12C7 11.4477 7.44772 11 8 11H32ZM33 28H7H5V29H6.75H33.25H35V28H33ZM31 13.5L31 24.5H9L9 13.5H31Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopAppleMacbook);
export default __webpack_public_path__ + "static/media/laptop-apple-macbook.81cb8ab3afda2d7da4e46c50466d4f05.svg";
export { ForwardRef as ReactComponent };